import { apiFetch, apiPostCustomBody } from "@/utils";

function getMaterielList() {
  return apiFetch("materielinformatique");
}

function getMaterielListByUserGuid(userGuid) {
  return apiFetch("materielinformatique?userGuid=" + userGuid);
}

function getMaterielListByMaterielId(id) {
  return apiFetch("materielinformatique/materiel?id=" + id);
}

function getMaterielCaracteristique() {
  return apiFetch("materielinformatique/caracteristique");
}

function resetCaracteristiquesForMateriel(id) {
  return apiFetch("materielinformatique/reset?materielId=" + id);
}

function createMateriel(name) {
  return apiFetch("materielinformatique/create?materielName=" + name);
}

function createCaracteristiquesForMateriel(materielId, caraCode, val) {
  return apiPostCustomBody("materielinformatique/create/caracteristique", {
    materielId,
    caracteristiqueCode: caraCode,
    value: val
  });
}

export default {
  getMaterielList,
  getMaterielListByUserGuid,
  getMaterielListByMaterielId,
  getMaterielCaracteristique,
  resetCaracteristiquesForMateriel,
  createMateriel,
  createCaracteristiquesForMateriel
};
export {
  getMaterielList,
  getMaterielListByUserGuid,
  getMaterielListByMaterielId,
  getMaterielCaracteristique,
  resetCaracteristiquesForMateriel,
  createMateriel,
  createCaracteristiquesForMateriel
};



// WEBPACK FOOTER //
// ./src/utils/materielinformatique.js